module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "su-tip"
  }, [_vm._v("提交成功！")]), _vm._v(" "), _c('div', {
    staticClass: "fs-32 color-999 text-center mt-30"
  }, [_vm._v("\n        非常感谢您提出的问题和意见\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "su-btn",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'home'
        });
      }
    }
  }, [_vm._v("返回首页")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c17246","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/My/contactSuccess.vue
// module id = X1Jl
// module chunks = 51